import styled from 'styled-components';

export const StyledImage = styled.img`
  ${({ rounded }) => rounded && `border-radius: 5px;`}
  ${({ size }) =>
    size === 'sm' ? `max-width: 326px;` : size === 'md' && `max-width: 547px;`}
  width: 100%;
`;
